/** Navigatie: dezelfde 14 routes als de huidige bundle, in dezelfde volgorde
 *  en met dezelfde secties als de stijlreferentie. */
export interface NavItem {
  route: string
  label: string
  icon: string
  badge?: string
  section?: string
}

export const NAV: NavItem[] = [
  { route: 'dashboard', label: 'Dashboard', icon: '▦', section: 'Overview' },
  { route: 'personas', label: 'Models', icon: '◍' },
  // 21-10-2026 [chat] (Jordy): welkomst-DM en bio per model, alleen owner/admin.
  { route: 'model-texts', label: 'Model texts', icon: '✎' },
  { route: 'chatters', label: 'Chatters', icon: '☺' },
  { route: 'fans', label: 'Fans', icon: '⚇' },
  { route: 'content', label: 'Content', icon: '▤' },
  { route: 'rules', label: 'Rules', icon: '⚖' },
  { route: 'analytics', label: 'Analytics', icon: '📊' },
  { route: 'conversations', label: 'Chats', icon: '✉', section: 'Engagement' },
  // 02-10-2026 (Jordy): Mass Messages hoort bij Chats, direct eronder.
  { route: 'mass-messages', label: 'Mass Messages', icon: '📣' },
  { route: 'posting', label: 'Posting Bot', icon: '⤴', section: 'Automation' },
  { route: 'paid-posting', label: 'Paid Posting Bot', icon: '$' },
  // 24-10-2026 (Jordy): social (Instagram, Threads, X); owner/admin, of het token instagram_page.
  { route: 'instagram', label: 'Social', icon: '◎' },
  { route: 'earnings', label: 'Earnings', icon: '€', section: 'Finance & Growth' },
  { route: 'follower-tracking', label: 'Follower Tracking', icon: '↗' },
  // 14-10-2026 [mm] (Jordy): post performance + MM/traffic, alleen owner/admin.
  { route: 'tracking', label: 'Tracking', icon: '◔' },
  // 20-10-2026 [mm]: Promo Auto MM, alleen owner/admin.
  { route: 'promo-mm', label: 'Promo Auto MM', icon: '✦' },
  { route: 'hashtags', label: 'Hashtags', icon: '#' },
  { route: 'console', label: 'Logs', icon: '›_', section: 'System' },
  // 07-10-2026 (Jordy): opnieuw inloggen bij F2F, alleen owner/admin.
  { route: 'f2f-login', label: 'F2F login', icon: '⚿' },
  { route: 'settings', label: 'Settings', icon: '⚙' },
  // 18-10-2026 (Jordy): vragen aan de Help-assistent, met wie ze stelde; alleen owner.
  { route: 'help-log', label: 'Help questions', icon: '?' },
]

export const SUB: Record<string, string> = {
  dashboard: 'Live overview across all models and platforms',
  personas: 'FanCentro + F2F',
  'model-texts': 'Welcome DM and bio per model · copy to the platform yourself',
  chatters: 'Team performance, shifts & compensation',
  fans: 'Fans across both platforms',
  content: 'Per-model media libraries',
  rules: 'Automation rules for the AI chat engine',
  analytics: 'Conversations, audience & AI performance',
  conversations: 'Shared inbox, live feed & queues',
  posting: 'Auto-posting engine · parallel scheduling & vault cleanup',
  earnings: 'Revenue, payouts & chatter commission',
  'follower-tracking': 'Follower growth, scoreboard & best times to post',
  tracking: 'Post performance & mass message traffic',
  hashtags: 'Tag library for FanCentro & F2F',
  console: 'Live application log stream',
  'f2f-login': 'Log in to F2F again (human check by you)',
  settings: 'System configuration & health',
  'help-log': 'Questions to the Help assistant, per chatter',
}
